export const formsData = {
    "standard": [
        {
            "id": "llp-forms",
            "name": "LLP Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/LLP_Forms/LLP_Forms.aspx"
        },
        {
            "id": "nbfc-forms",
            "name": "NBFC Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/NBFC_Forms/NBFC_Forms.aspx"
        },
        {
            "id": "service-tax-forms",
            "name": "Service Tax Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/Service_Tax_Forms/Service_Tax_Forms.aspx"
        },
        {
            "id": "wealth-tax-forms",
            "name": "Wealth Tax Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/Wealth_Tax_Forms/Wealth_Tax_Forms.aspx"
        },
        {
            "id": "income-declaration-form",
            "name": "Income Declaration Form",
            "originalUrl": "https://asrm.co.in/resources/Forms/income_declaration_form/income_declaration_form.aspx"
        },
        {
            "id": "roc-forms-companies-act-2013",
            "name": "ROC Forms (Companies Act, 2013)",
            "originalUrl": "https://asrm.co.in/resources/Forms/ROC_Forms_As_per_Companies_Act_2013/ROC_Forms_As_per_Companies_Act_2013.aspx"
        },
        {
            "id": "income-tax-forms",
            "name": "Income Tax Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/Income_Tax_Forms/Income_Tax_Forms.aspx"
        },
        {
            "id": "roc-forms-1956",
            "name": "ROC Forms (Companies Act, 1956)",
            "originalUrl": "https://asrm.co.in/resources/Forms/ROC_Forms_1956/ROC_Forms_1956.aspx"
        },
        {
            "id": "fema-forms",
            "name": "FEMA Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/FEMA/FEMA.aspx"
        }
    ],
    "cgst": [
        {
            "id": "cgst-registration-forms",
            "name": "Registration Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/CGST_Forms/Registration_Forms/Registration_Forms.aspx"
        },
        {
            "id": "cgst-gst-forms",
            "name": "GST Forms (General)",
            "originalUrl": "https://asrm.co.in/resources/Forms/CGST_Forms/GST_Forms/GST_Forms.aspx"
        },
        {
            "id": "cgst-returns-forms",
            "name": "Returns Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/CGST_Forms/Returns/Returns.aspx"
        },
        {
            "id": "cgst-refund-forms",
            "name": "Refund Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/CGST_Forms/Refund/Refund.aspx"
        },
        {
            "id": "cgst-itc-forms",
            "name": "Input Tax Credit Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/CGST_Forms/Input_Tax_Credit_Forms/Input_Tax_Credit_Forms.aspx"
        },
        {
            "id": "cgst-payment-forms",
            "name": "Payment of Tax Forms",
            "originalUrl": "https://asrm.co.in/resources/Forms/CGST_Forms/Payment_of_Tax/Payment_of_Tax.aspx"
        }
    ]
};
